/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 3.34 PM
 */

import addHours from 'date-fns/addHours';
import { api, cookie } from 'utils/index';

export function removeAllAuthCookies() {
    cookie.remove('tpanel');
    cookie.remove('rtpanel');

    delete api.defaults.headers.common.Authorization;
}

function setAuthorization(response) {
    const { access_token } = response.token;
    const options = { secure: true, path: '/' };

    cookie.set('tpanel', access_token, { ...options, expires: addHours(new Date(), 1) });

    api.defaults.headers.common.Authorization = `Bearer ${access_token}`;
}

const defaultState = { authenticated: false, user: null, errors: null };

export default {
    state: defaultState,
    reducers: {
        resetAuth: (state) => ({ ...state, ...defaultState }),
        verificationResponse: (state, payload) => {
            if (payload.errors) {
                removeAllAuthCookies();
                return { ...state, authenticated: false };
            }

            if (payload.token) {
                setAuthorization(payload);
            }

            return { ...state, authenticated: true };
        },
        loginResponse: (state, payload) => {
            if (payload.errors) {
                removeAllAuthCookies();

                return { ...state, errors: payload.errors };
            }

            setAuthorization(payload);

            return { ...state, authenticated: true };
        },
        logoutResponse: (state) => {
            removeAllAuthCookies();

            return { ...state, loggingOut: false, authenticated: false };
        },
    },
    effects: ({
        async login(data) {
            await api.post('login', data)
                .then((response) => this.loginResponse(response));
        },

        async logout() {
            await api.post('logout')
                .then((response) => this.logoutResponse(response));
        },

        async verify() {
            await api.post('token/validation')
                .then((response) => this.verificationResponse(response));
        },
    }),
};
